<template>
    <div>
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-dark"><i class="nav-icon far fa-comment-dots"></i> Diga Aí <small>Listagem de Diga Aí</small></h1>
                    </div>
                    <!-- /.col -->
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <router-link to="/dashboard">
                                    <i class="nav-icon fas fa-home"></i> Home
                                </router-link>
                            </li>
                            <li class="breadcrumb-item active"><i class="nav-icon far fa-comment-dots"></i> Diga Aí</li>
                        </ol>
                    </div>
                    <!-- /.col -->
                </div>
                <!-- /.row -->
            </div>
            <!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->
        <!-- Main content -->
        <section class="content">
            <div class="container-fluid">
                <div class="card card-primary card-outline">
                    <div class="card-header">
                        <h3 class="card-title"> Listagem de Diga Aí</h3>

                        <div class="card-tools">
                            <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
                                <i class="fas fa-minus"></i>
                            </button>
                            <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <router-link class="btn btn-app" :to="{ name: 'form-diga', params: { id: 0 }}">
                                <i class="fas far fa-comment-dots"></i> Cadastrar Diga Aí
                            </router-link>
                        </div>
                        <client-table :options="options">
                            <thead>
                                <tr>
                                    <th>Protocolo</th>
                                    <th>Data</th>
                                    <th>Nome</th>
                                    <th>E-mail</th>
                                    <th>Telefone</th>
                                    <th>Empresa</th>
                                    <th>Mensagem</th>
                                    <th>Tipo de Contato</th>
                                    <th>Status do Contato</th>
                                    <th class="min-tablet" style="width: 70px;">Ações</th>
                                </tr>
                            </thead>
                        </client-table>
                    </div>
                    <div class="card-footer">
                    </div>
                    <div class="overlay">
                        <a class="btn btn-app bg-secondary">
                            <i class="fas fa-spinner fa-pulse"></i> carregando...
                        </a>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>
        <!-- /.content -->
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                options: {
                    "title": "Diga Aí",
                    "ajax": {
                        "url": "/api/diga/datatable",
                        "data": function (d) {
                            return JSON.stringify($.extend({}, d, {
                            }));
                        }
                    },
                    "order": [[1, "desc"]],
                    "columns": [
                        {
                            "bSortable": false,
                            "mData": 'id_diga',
                            "mRender": function (data, type, full) {
                                return Date.parse(full.data_cadastro) - new Date().getTimezoneOffset() * 60000;
                            }
                        },
                        {
                            "bSortable": true,
                            "mData": 'data_cadastro',
                            "mRender": function (data, type, full) {
                                return new Date(full.data_cadastro).toLocaleString();
                            }
                        },
                        { "mData": 'nome', visible: false, searchable: false },
                        { "mData": 'email', visible: false, searchable: false },
                        { "mData": 'telefone', visible: false, searchable: false },
                        { "mData": 'empresa', visible: false, searchable: false },
                        { "mData": 'mensagem', visible: false, searchable: false },
                        { "mData": 'tipo_contato' }, 
                        { "mData": 'status_diga' },
                        {
                            "bSortable": false,
                            "mData": null,
                            "sClass": "text-center py-0",
                            "mRender": function (data, type, full) {
                                return `<div class="btn-group">
                                    <button onclick="$(this).trigger('edit', ${full.id_diga})" rel="tooltip" title="Editar" class="btn btn-sm btn-primary"><i class="fa fa-pencil"></i></button>
                                </div>`;
                            }
                        }
                    ]
                }
            };
        },
        mounted: function () {
            const vm = this;

            $("body").on("edit", function (event, id) { vm.$router.push({ name: 'form-diga', params: { id: id } }).catch(() => { }); });
        }
    };
</script>

<style scoped>
</style>